import { Icon } from "../icon"
import type { IconName } from "../icon/IconName";
import "./tag.css"

interface TagProps {
    label: string
    onClick?: () => void;
    icon?: string;
    variant?: "primary" | "secondary"
}

export const Tag = ({label, onClick, icon="dropdown", variant}: TagProps) => {
    return <div className={`tag tag-${variant}`}>
        <p className="tag-label">{label}</p>
        {!!icon && <div className="tag-close" onClick={onClick}><Icon className="icon-close" name={icon as IconName} size="small"/></div>}
    </div>
}